import { createApiQuery } from "@/hooks/use-api-query";
import { get } from "@/libs/http";

export const getAgreement = (params: { agreementType: string; }) => {
  return get('/user/auth/v1/agreement', {
    params
  });
};

export const useGetAgreement = createApiQuery(getAgreement,
  (params: { agreementType: string; }) => ['agreement', params.agreementType]);